import React from 'react';
import { createPortal } from 'react-dom'; // 🌟 ADDED THIS

const AlertModal = ({ isOpen, onClose, title = "Alert", message }) => {
  if (!isOpen) return null;

  // 🌟 WRAPPED THE ENTIRE RETURN IN createPortal 🌟
  return createPortal(
    <>
      {/* ── CUSTOM ANIMATIONS (Injected locally for instant use) ── */}
      <style>
        {`
          @keyframes blowUp {
            0% { transform: scale(0.8); opacity: 0; }
            50% { transform: scale(1.03); opacity: 1; }
            100% { transform: scale(1); opacity: 1; }
          }
          @keyframes iconPop {
            0% { transform: scale(0.3) rotate(-10deg); opacity: 0; }
            60% { transform: scale(1.15) rotate(5deg); opacity: 1; }
            100% { transform: scale(1) rotate(0deg); opacity: 1; }
          }
          @keyframes drawMark {
            0% { stroke-dashoffset: 20; opacity: 0; }
            100% { stroke-dashoffset: 0; opacity: 1; }
          }
        `}
      </style>

      {/* Backdrop */}
      <div className="fixed inset-0 z-[100000] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4 transition-opacity duration-300">
        
        {/* Modal Box: Boxy Theme (rounded-lg instead of rounded-3xl) */}
        <div 
          className="bg-white rounded-lg w-full max-w-sm p-6 shadow-[0_20px_50px_-12px_rgba(0,0,0,0.3)] relative border border-gray-200 flex flex-col items-center text-center"
          style={{ animation: 'blowUp 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards' }}
        >
          
          {/* Close Button: Boxy (rounded-md instead of rounded-full) */}
          <button 
            onClick={onClose} 
            className="absolute top-4 right-4 w-8 h-8 rounded-md bg-gray-50 hover:bg-gray-100 text-gray-400 hover:text-gray-600 font-bold flex items-center justify-center transition-colors focus:outline-none focus:ring-2 focus:ring-gray-200"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="square" strokeLinejoin="miter" strokeWidth="2.5" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>

          {/* Animated Error Logo: Sharp, Boxy Container */}
          <div 
            className="w-16 h-16 bg-red-50 rounded-lg flex items-center justify-center mb-5 border border-red-100 shadow-sm"
            style={{ animation: 'iconPop 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards 0.1s', opacity: 0 }}
          >
            <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {/* Sharp Octagon Outline */}
              <path 
                strokeLinecap="square" 
                strokeLinejoin="miter" 
                strokeWidth="2" 
                d="M8.228 4h7.544l5.228 5.228v7.544l-5.228 5.228H8.228L3 16.772V9.228L8.228 4z"
              />
              {/* Animated Exclamation Mark */}
              <path 
                strokeLinecap="square" 
                strokeWidth="2.5" 
                d="M12 8v5" 
                strokeDasharray="20"
                style={{ animation: 'drawMark 0.4s ease-out forwards 0.4s', opacity: 0 }}
              />
              <path 
                strokeLinecap="square" 
                strokeWidth="3" 
                d="M12 16h.01" 
                strokeDasharray="20"
                style={{ animation: 'drawMark 0.2s ease-out forwards 0.6s', opacity: 0 }}
              />
            </svg>
          </div>

          {/* Alert Content */}
          <h3 className="text-xl font-bold text-gray-900 mb-2 leading-tight">
            {title}
          </h3>
          <p className="text-sm text-gray-600 font-medium leading-relaxed mb-7 px-2">
            {message}
          </p>

          {/* Action Button: Boxy Theme (rounded-md instead of rounded-xl) */}
          <button
            onClick={onClose}
            className="w-full py-3.5 rounded-md font-bold text-white bg-red-600 hover:bg-red-700 active:scale-[0.98] transition-all shadow-sm focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
          >
            Understood
          </button>

        </div>
      </div>
    </>,
    document.body // 🌟 TELEPORTS MODAL TO THE ROOT LEVEL 🌟
  );
};

export default AlertModal;